const childRoutes = (prop) => [
  {
    path: 'rehabilitation-information',
    name: prop + '.rehabilitation_information',
    meta: { auth: true },
    component: () => import('../pages/rehabilitation-information/List.vue')
  },
  {
    path: 'followup-management',
    name: prop + '.followup_management',
    meta: { auth: true },
    component: () => import('../pages/followup-management/List.vue')
  },
  {
    path: 'approval-management',
    name: prop + '.approval_management',
    meta: { auth: true },
    component: () => import('../pages/approval-management/List.vue')
  },
  {
    path: 'disciplinary-action',
    name: prop + '.disciplinary_action',
    meta: { auth: true },
    component: () => import('../pages/disciplinary-action/List.vue')
  },
  {
    path: 'initial-listing-management',
    name: prop + '.initial_listing_management',
    meta: { auth: true },
    component: () => import('../pages/initial-listing-management/List.vue')
  },
  {
    path: 'meeting-management',
    name: prop + '.meeting_management',
    meta: { auth: true },
    component: () => import('../pages/meeting-management/List.vue')
  },
  {
    path: 'resident-incident-info',
    name: prop + '.resident_incident_info',
    meta: { auth: true },
    component: () => import('../pages/resident-incident-info/List.vue')
  },
  {
    path: 'e-notification',
    name: prop + '.e_notification',
    meta: { auth: true },
    component: () => import('../pages/e-notification/List.vue')
  },
  {
    path: 'parents-meeting',
    name: prop + '.parents_meeting',
    meta: { auth: true },
    component: () => import('../pages/parents-meeting/List.vue')
  }
]
const routes = [{
  path: '/child-service/rehabilitation-management',
  name: 'child_service.rehabilitation_management',
  component: () => import('@/layouts/ChildServiceLayout.vue'),
  meta: { auth: true },
  children: childRoutes('child_service.rehabilitation_management')
}]

export default routes
